import React from "react";
import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";

export function InactivityWarningModal({
  open,
  remainingMs,
  onStay,
  onLogout,
}) {
  const { t } = useTranslation();
  const seconds = Math.max(0, Math.ceil(remainingMs / 1000));

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onStay()}>
      <DialogContent
        data-testid="inactivity-warning-modal"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        className="max-w-md border-border-subtle bg-surface text-text-primary [&>button.absolute]:hidden"
      >
        <DialogHeader>
          <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-status-limited/10">
            <AlertCircle className="h-5 w-5 text-status-limited" />
          </div>
          <DialogTitle>{t("session.warning_title")}</DialogTitle>
          <DialogDescription className="text-text-secondary">
            {t("session.warning_body")}
          </DialogDescription>
        </DialogHeader>

        <div
          className="rounded-md border border-border-subtle bg-offwhite/60 px-4 py-3 text-center"
          aria-live="polite"
        >
          <div className="text-xs uppercase tracking-wide text-text-secondary">
            {t("session.countdown_label")}
          </div>
          <div
            className="mt-1 font-mono text-2xl font-semibold text-text-primary"
            data-testid="inactivity-countdown"
          >
            {seconds}s
          </div>
        </div>

        <DialogFooter className="sm:justify-end">
          <Button
            variant="outline"
            onClick={onLogout}
            data-testid="inactivity-logout-now"
            className="border-border-subtle text-text-primary hover:bg-offwhite"
          >
            {t("session.logout_now")}
          </Button>
          <Button
            onClick={onStay}
            data-testid="inactivity-stay"
            className="bg-charcoal text-white hover:bg-charcoal-soft focus-visible:ring-champagne"
          >
            {t("session.stay_signed_in")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
